import { Injectable, inject } from "@angular/core";
import { MatIconRegistry } from "@angular/material/icon";
import { DomSanitizer } from "@angular/platform-browser";

@Injectable({ providedIn: "root" })
export class IconRegistryService {
  private readonly matIconRegistry = inject(MatIconRegistry);
  private readonly domSanitizer = inject(DomSanitizer);

  private readonly ICON_PATH = "icons";

  private readonly icons = [
    "loans",
    "logo",
    "bell",
    "logout",
    "user",
    "logo-full",
  ];

  registerIcons(): void {
    this.icons.forEach((icon) => {
      this.matIconRegistry.addSvgIcon(
        icon,
        this.domSanitizer.bypassSecurityTrustResourceUrl(
          `${this.ICON_PATH}/${icon}.svg`,
        ),
      );
    });
  }
}
